module.exports = __webpack_public_path__ + "img/mgh-toyosu-bayside-cross-tokyo.5a236bad.jpg";